<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name')"
      label-for="input-name"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.modality_egress_profile.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description')"
      label-for="input-description"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div
        class="form-description mb-2"
        @click="$bvModal.show(`edit-description-modal`)"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="modality_egress_profile.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-description-modal`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="modality_egress_profile"
        :content_rich_text="modality_egress_profile.description"
        :show_last_modification="true"
        :permit_blank="true"
        @save="(content) => patchDescription(modality_egress_profile, content)"
        @close="$bvModal.hide(`edit-description-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-description-modal`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="modality_egress_profile"
          :Text="modality_egress_profile.description"
          @save="patchDescription"
          @close="$bvModal.hide(`edit-description-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <!-- <b-form-textarea
        id="input-description"
        name="input-description"
        v-model="$v.modality_egress_profile.description.$model"
        :state="validateState('description')"
        aria-describedby="input-description-live-feedback"
        size="md"
        rows="3"
        max-rows="8"
      ></b-form-textarea> -->
      <b-form-invalid-feedback id="input-description-live-feedback">{{
        $t("reusable.common.minLength", { min: 5 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(modality_egress_profile.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate
        :Information="modality_egress_profile"
      ></ModificationDate>
    </b-form-group>
    <div class="row">
      <div
        v-if="show_delete_button && !isNaN(this.modality_egress_profile.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="deleteModality"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import * as names from "@/store/names";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { toast } from "@/utils/utils";
export default {
  name: "ModalityEgressProfileForm",
  mixins: [validationMixin],
  components: {
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    modalityEgressProfile: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          school: "",
          active: true,
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    institution_id: {
      type: Number,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modality_egress_profile: this.modalityEgressProfile
        ? {
            id: this.modalityEgressProfile.id,
            name: this.modalityEgressProfile.name,
            description: this.modalityEgressProfile.description,
            creation_date: this.modalityEgressProfile.creation_date,
            created_by: this.modalityEgressProfile.created_by,
            updated_by: this.modalityEgressProfile.updated_by,
            update_date: this.modalityEgressProfile.update_date,
          }
        : { id: generateUniqueId(), name: "" },
    };
  },
  validations: {
    modality_egress_profile: {
      name: {
        required,
        minLength: minLength(3),
      },
      description: {
        // required,
        // minLength: minLength(5),
      },
    },
  },
  created() {},
  methods: {
    patchDescription(object, text) {
      this.modality_egress_profile.description = text;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.modality_egress_profile[name];
      return $dirty ? !$error : null;
    },
    save() {
      this.$v.modality_egress_profile.$touch();
      if (this.$v.modality_egress_profile.$anyError) {
        return;
      }
      if (isNaN(this.modality_egress_profile.id)) {
        this.createModality();
      } else this.updateModality();
    },
    createModality() {
      this.modality_egress_profile.school = this.institution_id;
      this.$store
        .dispatch(
          names.POST_MODALITY_EGRESS_PROFILE,
          this.modality_egress_profile
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.modalityegressprofile",
                false,
                "Modalidad del Perfil de Egreso"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateModality() {
      this.modality_egress_profile.school = this.institution_id;
      this.$store
        .dispatch(
          names.UPDATE_MODALITY_EGRESS_PROFILE,
          this.modality_egress_profile
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.modalityegressprofile",
                false,
                "Modalidad del Perfil de Egreso"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    deleteModality() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.modalityegressprofile",
            false,
            "Modalidad del Perfil de Egreso"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_MODALITY_EGRESS_PROFILE,
            this.modality_egress_profile.id
          );
          this.$emit("deleted", this.modality_egress_profile);
        }
      });
    },
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
</style>